/** Flow is disabled on purpose, too hard to handle the union in NotificationType */

import React from 'react';
import { NotificationMessage } from './message/NotificationMessage';
import { NotificationWatcher } from './watcher/NotificationWatcher';
import { NotificationWatcherDecision } from './watcher/NotificationWatcherDecision';
import { NotificationFolderWatcher } from './watcher/NotificationFolderWatcher';
import { Connect } from './NotificationListContainer';
import {
  NotificationType,
  NotificationWatcherType,
  NotificationWatcherDecisionType,
  NotificationFolderWatcherType,
  NotificationMessageType,
} from '../../notification.types';

type Props = {
  notifList: Array<NotificationType>;
  readNotificationContent: Function;
};

export class RawNotificationList extends React.Component<Props> {
  getNotificationRow = (notif: NotificationType) => {
    const { readNotificationContent } = this.props;

    const watcherNotif = notif as NotificationWatcherType;
    if (watcherNotif.data.watcher) {
      return (
        <NotificationWatcher
          notification={watcherNotif}
          notificationClicked={readNotificationContent}
        />
      );
    }

    const watcherDecisionNotif = notif as NotificationWatcherDecisionType;
    if (watcherDecisionNotif.data.watcherDecision) {
      return (
        <NotificationWatcherDecision
          notification={watcherDecisionNotif}
          notificationClicked={readNotificationContent}
        />
      );
    }

    const folderWatcherNotif = notif as NotificationFolderWatcherType;
    if (folderWatcherNotif.data.folderWatcher) {
      return (
        <NotificationFolderWatcher
          notification={folderWatcherNotif}
          notificationClicked={readNotificationContent}
        />
      );
    }

    const messageNotif = notif as NotificationMessageType;
    if (messageNotif.data.message) {
      return (
        <NotificationMessage
          notification={messageNotif}
          notificationClicked={readNotificationContent}
        />
      );
    }
    return <span />;
  };

  render() {
    const { notifList } = this.props;
    return (
      <ul className="notification-list">
        {notifList.length > 0 &&
          notifList.map(notif => (
            <li key={notif.id} className="notification-list__item">
              {this.getNotificationRow(notif)}
            </li>
          ))}
        {notifList.length === 0 && (
          <li>
            <p className="notification-list__item notification-list__empty">
              Vous n’avez pas encore reçu de notification.
            </p>
          </li>
        )}
      </ul>
    );
  }
}

export const NotificationList = Connect(RawNotificationList);
